import Insights from './Insights.Container';

export default Insights;
